'use strict';

const POLL_FREQUENCY = 1000 * 60 * 5, // minutes
    RestUtils = require('./../utils/RestUtils'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('./../stores/SessionStore'),
    ContentUtils = require('./../utils/ContentUtils'),
    packageJson = require('../../package.json'),
    Security = require('./../services/Security').auth,
    {delay} = require('lodash/function'),
    notification = require('./../components/Notification/Notification'),
    AppAction = require('../actions/AppActionCreators'),
    categories = require('../constants/AppConstants').Analytics.categories,
    actions = require('../constants/AppConstants').Analytics.actions,
    ga = require('react-ga');

/**
 * The simple polling class that ask for changes against to version of the server.
 * @type {{inProgress: boolean, intervalId: *, poll: Function, start: Function, stop: Function}}
 */
const PollerAppVersion = {

    /**
     * The flag that allow as to not pull other request after finish the previous one.
     */
    inProgress: false,

    /**
     * The native interval id that allow as to stop the cycle when we need it.
     */
    intervalId: null,

    /**
     * Poll against the resources defined in dashboard to ask for dashboard changes.
     */
    poll: function () {
        if (this.inProgress) {
            return;
        }
        const self = this;
        const ajax = RestUtils.createXHR();
        const path = process.env.URL_API + '/api/app/version';

        this.inProgress = true;

        ajax.addEventListener('error', function (error) {
            if (!error) {
                error = {};
            }
            if (!error.type) {
                error.type = '';
            }
            try {
                console.warn('PollerAppVersion Error: ' + this.responseText + ' type: ' + error.type + ' loaded: ' + error.loaded);
            } catch (error) {
                // do-nothing
            }
            self.inProgress = false;
        });

        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                
                try {
                    const license = SessionStore.isFullPaidVersion()
                      ? 'FULL-VERSION'
                      : SessionStore.isBasePaidVersion()
                        ? 'BASE-VERSION'
                        : 'TRIAL-VERSION';
                    ga.event({
                        category: categories.APPLICATION,
                        action: actions.A_LIVE,
                        label: `${packageJson.version}v | ${license} | app: ${SessionStore.getCurrentApplicant()} user: ${ContentUtils.getSession('userNameSession')}`
                    });
                    if (this.responseText.indexOf('version') > -1) {
                        const currentAppVersionFetched = +JSON.parse(this.responseText).version;
                        if (SessionStore.getCurrentAppVersion() < currentAppVersionFetched) {
                            SessionStore.setCurrentAppVersion(currentAppVersionFetched);
                            notification.show(t('dashboard_notification_new_brewplanner_version'), 'info', 5);
                            delay(function () {
                                AppAction.updatingNewVersionApi();
                            }, 5000);
                        }
                    }
                    self.inProgress = false;
                    
                } catch (error) {
                    self.inProgress = false;
                    PollerAppVersion.stop();
                    PollerAppVersion.start(); // start over again.
                }
            }, function () {
                // retry again
                self.inProgress = false;
            });
        });

        ajax.open('GET', path);
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        ajax.send();
    },

    /**
     * Start pulling.
     */
    start: function () {
        this.refreshIntervalId = setInterval(this.poll, POLL_FREQUENCY);
    },

    /**
     * Stop pulling.
     */
    stop: function () {
        clearInterval(this.refreshIntervalId);
    }
};

module.exports = PollerAppVersion;



/** WEBPACK FOOTER **
 ** ./src/pollers/PollerAppVersion.js
 **/